// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.App {
  min-height: 100vh;
  display: flex;
  background: #f5f7fa;
}

/* ============================================
   SIDEBAR MODERNA
   ============================================ */

.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  background: var(--ink, #15140F);
  color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.25);
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
}

.sidebar.collapsed {
  width: 80px;
}

/* Header do Sidebar */
.sidebar-header {
  padding: 26px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--line-dark, #3A3728);
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 12px;
  overflow: hidden;
}

.sidebar-logo h2 {
  font-family: 'Oswald', sans-serif;
  font-size: 19px;
  font-weight: 600;
  letter-spacing: .02em;
  text-transform: uppercase;
  color: var(--text-inv, #F0ECE0);
  white-space: nowrap;
  transition: opacity 0.3s;
}

.sidebar.collapsed .sidebar-logo h2 {
  opacity: 0;
  width: 0;
}

.logo-icon { flex: none; }

.sidebar-toggle {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid var(--line-dark, #3A3728);
  color: var(--text-inv-dim, #A9A794);
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--text-inv, #F0ECE0);
}

/* Navegação */
.sidebar-nav {
  flex: 1 1;
  padding: 16px 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 3px;
}

.nav-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin: 0;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  color: var(--text-inv-dim, #A9A794);
  text-decoration: none;
  transition: background .15s, color .15s;
  margin: 3px 10px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.06);
  color: var(--text-inv, #F0ECE0);
}

.nav-link.active {
  background: var(--cobalt, #1F4FD8);
  color: #fff;
  font-weight: 600;
}

.nav-link.highlight:not(.active) {
  color: var(--amber, #C77C1F);
}

.nav-icon {
  min-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-label {
  white-space: nowrap;
  transition: opacity 0.3s;
}

.sidebar.collapsed .nav-label {
  opacity: 0;
  width: 0;
}

.sidebar.collapsed .nav-link {
  justify-content: center;
  padding: 12px;
}

/* Footer do Sidebar */
.sidebar-footer {
  padding: 18px 20px;
  border-top: 1px solid var(--line-dark, #3A3728);
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 999px;
  background: var(--ink-700, #242219);
  border: 1px solid var(--line-dark, #3A3728);
  color: var(--text-inv-dim, #A9A794);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-details {
  flex: 1 1;
  overflow: hidden;
}

.user-email {
  display: block;
  font-size: 12px;
  color: var(--text-inv-dim, #A9A794);
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.btn-logout {
  background: transparent;
  border: 1px solid var(--red-bg, #F8E3E0);
  color: var(--red, #B33A2E);
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  width: 100%;
}

.btn-logout:hover {
  background: var(--red, #B33A2E);
  color: white;
  border-color: var(--red, #B33A2E);
}

.sidebar.collapsed .user-details {
  display: none;
}

.sidebar.collapsed .user-info {
  justify-content: center;
}

/* ============================================
   MAIN CONTENT
   ============================================ */

.main-content {
  flex: 1 1;
  margin-left: 280px;
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 100vh;
  width: calc(100% - 280px);
}

.App:has(.sidebar.collapsed) .main-content {
  margin-left: 80px;
  width: calc(100% - 80px);
}

/* Ajuste para quando não há sidebar (página de login) */
.App:not(:has(.sidebar)) .main-content {
  margin-left: 0;
  width: 100%;
}

.page-header {
  margin-bottom: 30px;
}

.page-header h1 {
  color: #333;
  margin-bottom: 10px;
}

.page-header p {
  color: #666;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background: #2196F3;
  color: white;
}

.btn-primary:hover {
  background: #1976D2;
}

.btn-success {
  background: #4CAF50;
  color: white;
}

.btn-success:hover {
  background: #45a049;
}

.btn-info {
  background: #2196F3;
  color: white;
}

.btn-info:hover {
  background: #1976D2;
}

.btn-warning {
  background: #FF9800;
  color: white;
}

.btn-warning:hover {
  background: #F57C00;
}

.btn-danger {
  background: #f44336;
  color: white;
}

.btn-danger:hover {
  background: #da190b;
}

.btn-secondary {
  background: #757575;
  color: white;
}

.btn-secondary:hover {
  background: #616161;
}

.table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background: #f5f5f5;
}

th {
  padding: 15px;
  text-align: left;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #ddd;
}

td {
  padding: 15px;
  border-bottom: 1px solid #eee;
}

tr:hover {
  background: #f9f9f9;
}

.form-container {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #2196F3;
}

.card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.card h3 {
  color: #333;
  margin-bottom: 15px;
}

.actions {
  display: flex;
  gap: 10px;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #666;
}

.error {
  background: #ffebee;
  color: #c62828;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.success {
  background: #e8f5e9;
  color: #2e7d32;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
}

/* Estilos de Busca e Filtros */
.search-filters-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 25px;
}

.search-box {
  position: relative;
  margin-bottom: 15px;
}

.search-input {
  width: 100%;
  padding: 12px 40px 12px 15px;
  font-size: 15px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s;
}

.search-input:focus {
  outline: none;
  border-color: var(--cobalt, #1F4FD8);
  box-shadow: 0 0 0 3px var(--cobalt-bg, #E8EEFC);
}

.clear-search {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: #e0e0e0;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: all 0.2s;
}

.clear-search:hover {
  background: #d0d0d0;
  color: #333;
}

.filters-row {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.filter-select {
  flex: 1 1;
  min-width: 200px;
  padding: 10px 12px;
  font-size: 14px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-select:focus {
  outline: none;
  border-color: var(--cobalt, #1F4FD8);
  box-shadow: 0 0 0 3px var(--cobalt-bg, #E8EEFC);
}

.results-info {
  color: #666;
  font-size: 14px;
  padding: 10px 0;
  border-top: 1px solid #e0e0e0;
}

.results-info strong {
  color: var(--cobalt, #1F4FD8);
  font-weight: 600;
}

/* ============================================
   RESPONSIVIDADE
   ============================================ */

@media (max-width: 768px) {
  .sidebar {
    width: 80px;
  }

  .sidebar.collapsed {
    transform: translateX(-100%);
  }

  .sidebar-logo h2,
  .nav-label,
  .user-details {
    opacity: 0;
    width: 0;
  }

  .nav-link {
    justify-content: center;
    padding: 16px;
  }

  .user-info {
    justify-content: center;
  }

  .main-content {
    margin-left: 80px !important;
    width: calc(100% - 80px) !important;
  }

  .App:has(.sidebar.collapsed) .main-content {
    margin-left: 0 !important;
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .page-header h1 {
    font-size: 24px;
  }
  
  .sidebar {
    width: 70px;
  }
  
  .main-content {
    margin-left: 70px !important;
    width: calc(100% - 70px) !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA,aAAa,UAAU,EAAE;;AAEzB;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA,cAAc;AACd;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,2CAA2C;EAC3C,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;EACxC,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD;EACE,SAAO;EACP,kBAAkB;EAClB,yDAAyD;EACzD,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,wDAAwD;AACxD;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;;;IAGE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,mCAAmC;EACrC;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,mCAAmC;EACrC;AACF","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  background: #f5f7fa;\n}\n\n/* ============================================\n   SIDEBAR MODERNA\n   ============================================ */\n\n.sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 280px;\n  background: var(--ink, #15140F);\n  color: white;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.25);\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 1000;\n}\n\n.sidebar.collapsed {\n  width: 80px;\n}\n\n/* Header do Sidebar */\n.sidebar-header {\n  padding: 26px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--line-dark, #3A3728);\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  overflow: hidden;\n}\n\n.sidebar-logo h2 {\n  font-family: 'Oswald', sans-serif;\n  font-size: 19px;\n  font-weight: 600;\n  letter-spacing: .02em;\n  text-transform: uppercase;\n  color: var(--text-inv, #F0ECE0);\n  white-space: nowrap;\n  transition: opacity 0.3s;\n}\n\n.sidebar.collapsed .sidebar-logo h2 {\n  opacity: 0;\n  width: 0;\n}\n\n.logo-icon { flex: none; }\n\n.sidebar-toggle {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid var(--line-dark, #3A3728);\n  color: var(--text-inv-dim, #A9A794);\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar-toggle:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--text-inv, #F0ECE0);\n}\n\n/* Navegação */\n.sidebar-nav {\n  flex: 1;\n  padding: 16px 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.sidebar-nav::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 3px;\n}\n\n.nav-menu {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.nav-item {\n  margin: 0;\n}\n\n.nav-link {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 16px;\n  color: var(--text-inv-dim, #A9A794);\n  text-decoration: none;\n  transition: background .15s, color .15s;\n  margin: 3px 10px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.nav-link:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: var(--text-inv, #F0ECE0);\n}\n\n.nav-link.active {\n  background: var(--cobalt, #1F4FD8);\n  color: #fff;\n  font-weight: 600;\n}\n\n.nav-link.highlight:not(.active) {\n  color: var(--amber, #C77C1F);\n}\n\n.nav-icon {\n  min-width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.nav-label {\n  white-space: nowrap;\n  transition: opacity 0.3s;\n}\n\n.sidebar.collapsed .nav-label {\n  opacity: 0;\n  width: 0;\n}\n\n.sidebar.collapsed .nav-link {\n  justify-content: center;\n  padding: 12px;\n}\n\n/* Footer do Sidebar */\n.sidebar-footer {\n  padding: 18px 20px;\n  border-top: 1px solid var(--line-dark, #3A3728);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.user-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 999px;\n  background: var(--ink-700, #242219);\n  border: 1px solid var(--line-dark, #3A3728);\n  color: var(--text-inv-dim, #A9A794);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.user-details {\n  flex: 1;\n  overflow: hidden;\n}\n\n.user-email {\n  display: block;\n  font-size: 12px;\n  color: var(--text-inv-dim, #A9A794);\n  margin-bottom: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.btn-logout {\n  background: transparent;\n  border: 1px solid var(--red-bg, #F8E3E0);\n  color: var(--red, #B33A2E);\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  width: 100%;\n}\n\n.btn-logout:hover {\n  background: var(--red, #B33A2E);\n  color: white;\n  border-color: var(--red, #B33A2E);\n}\n\n.sidebar.collapsed .user-details {\n  display: none;\n}\n\n.sidebar.collapsed .user-info {\n  justify-content: center;\n}\n\n/* ============================================\n   MAIN CONTENT\n   ============================================ */\n\n.main-content {\n  flex: 1;\n  margin-left: 280px;\n  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  min-height: 100vh;\n  width: calc(100% - 280px);\n}\n\n.App:has(.sidebar.collapsed) .main-content {\n  margin-left: 80px;\n  width: calc(100% - 80px);\n}\n\n/* Ajuste para quando não há sidebar (página de login) */\n.App:not(:has(.sidebar)) .main-content {\n  margin-left: 0;\n  width: 100%;\n}\n\n.page-header {\n  margin-bottom: 30px;\n}\n\n.page-header h1 {\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.page-header p {\n  color: #666;\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s;\n  text-decoration: none;\n  display: inline-block;\n}\n\n.btn-primary {\n  background: #2196F3;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #1976D2;\n}\n\n.btn-success {\n  background: #4CAF50;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #45a049;\n}\n\n.btn-info {\n  background: #2196F3;\n  color: white;\n}\n\n.btn-info:hover {\n  background: #1976D2;\n}\n\n.btn-warning {\n  background: #FF9800;\n  color: white;\n}\n\n.btn-warning:hover {\n  background: #F57C00;\n}\n\n.btn-danger {\n  background: #f44336;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #da190b;\n}\n\n.btn-secondary {\n  background: #757575;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #616161;\n}\n\n.table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  overflow: hidden;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nthead {\n  background: #f5f5f5;\n}\n\nth {\n  padding: 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 2px solid #ddd;\n}\n\ntd {\n  padding: 15px;\n  border-bottom: 1px solid #eee;\n}\n\ntr:hover {\n  background: #f9f9f9;\n}\n\n.form-container {\n  background: white;\n  padding: 30px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  color: #333;\n  font-weight: 500;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #2196F3;\n}\n\n.card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 20px;\n}\n\n.card h3 {\n  color: #333;\n  margin-bottom: 15px;\n}\n\n.actions {\n  display: flex;\n  gap: 10px;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: #666;\n}\n\n.error {\n  background: #ffebee;\n  color: #c62828;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n.success {\n  background: #e8f5e9;\n  color: #2e7d32;\n  padding: 15px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n}\n\n/* Estilos de Busca e Filtros */\n.search-filters-container {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-bottom: 25px;\n}\n\n.search-box {\n  position: relative;\n  margin-bottom: 15px;\n}\n\n.search-input {\n  width: 100%;\n  padding: 12px 40px 12px 15px;\n  font-size: 15px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  transition: all 0.3s;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--cobalt, #1F4FD8);\n  box-shadow: 0 0 0 3px var(--cobalt-bg, #E8EEFC);\n}\n\n.clear-search {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #e0e0e0;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 14px;\n  color: #666;\n  transition: all 0.2s;\n}\n\n.clear-search:hover {\n  background: #d0d0d0;\n  color: #333;\n}\n\n.filters-row {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 15px;\n}\n\n.filter-select {\n  flex: 1;\n  min-width: 200px;\n  padding: 10px 12px;\n  font-size: 14px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: var(--cobalt, #1F4FD8);\n  box-shadow: 0 0 0 3px var(--cobalt-bg, #E8EEFC);\n}\n\n.results-info {\n  color: #666;\n  font-size: 14px;\n  padding: 10px 0;\n  border-top: 1px solid #e0e0e0;\n}\n\n.results-info strong {\n  color: var(--cobalt, #1F4FD8);\n  font-weight: 600;\n}\n\n/* ============================================\n   RESPONSIVIDADE\n   ============================================ */\n\n@media (max-width: 768px) {\n  .sidebar {\n    width: 80px;\n  }\n\n  .sidebar.collapsed {\n    transform: translateX(-100%);\n  }\n\n  .sidebar-logo h2,\n  .nav-label,\n  .user-details {\n    opacity: 0;\n    width: 0;\n  }\n\n  .nav-link {\n    justify-content: center;\n    padding: 16px;\n  }\n\n  .user-info {\n    justify-content: center;\n  }\n\n  .main-content {\n    margin-left: 80px !important;\n    width: calc(100% - 80px) !important;\n  }\n\n  .App:has(.sidebar.collapsed) .main-content {\n    margin-left: 0 !important;\n    width: 100% !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .page-header h1 {\n    font-size: 24px;\n  }\n  \n  .sidebar {\n    width: 70px;\n  }\n  \n  .main-content {\n    margin-left: 70px !important;\n    width: calc(100% - 70px) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
